// extracted by mini-css-extract-plugin
export default {"header__link":"HeaderLink_header__link__37C7I"};